import { useState, useEffect } from "react"
import ApiService from "@/services/Api"

type UseTemplateErrorTranslationInput = {
	templateId: number
	enabled: boolean
}

type UseTemplateErrorTranslationOutput = {
	translatedError: string | undefined
	isLoading: boolean
}

const useTemplateErrorTranslation = (input: UseTemplateErrorTranslationInput): UseTemplateErrorTranslationOutput => {
	const { templateId, enabled } = input

	const [translatedError, setTranslatedError] = useState<string | undefined>(undefined)
	const [isLoading, setIsLoading] = useState<boolean>(false)

	useEffect(() => {
		if (!enabled) {
			setIsLoading(false)
			return
		}

		let cancelled = false

		setIsLoading(true)

		const translate = async () => {
			try {
				const response = await ApiService.post<{ translatedError: string }>(
					"/waba/template-error/translate",
					{ templateId }
				)

				if (!cancelled) {
					setTranslatedError(response.data.translatedError)
				}
			} catch {
				if (!cancelled) {
					setTranslatedError(undefined)
				}
			} finally {
				if (!cancelled) {
					setIsLoading(false)
				}
			}
		}

		translate()

		return () => {
			cancelled = true
		}
	}, [templateId, enabled])

	return { translatedError, isLoading }
}

export default useTemplateErrorTranslation
